module.exports = __webpack_public_path__ + "img/wechat.d812bddc.jpeg";